import { render } from "./TheMobilityVehiclesContainer.vue?vue&type=template&id=b1a6fdb8"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__